module.controller('autoTransfersManageCtrl', ['$scope', '$stateParams', 'brandService', 'Session', '$http', 'baseURI', 'recurringTransferService', 'OVERLAY',
  function ($scope, $stateParams, brandService, Session, $http, baseURI, recurringTransferService, OVERLAY){
    $scope.overlay = OVERLAY['member.home.transfers/manage'];
    $scope.cardTransfers = [];
    $scope.bankTransfers = [];
    $scope.banks         = {};

    $scope.hideManageAutoBankLoads = $scope.brand.hideManageAutoBankLoads;
    $scope.hideManageAutoSends = $scope.brand.hideManageAutoSends;
    $scope.hideManageAutoWithdrawals = $scope.brand.hideManageAutoWithdrawals;


    // Get Card Transfers
    $http.get(baseURI + 'card/transfer/auto')
      .then(function (resp){
        var transfers = resp.data.Data;
        for(var t in transfers){
          switch (transfers[t].Frequency){
            case 'M':
              transfers[t].Frequency = 'O';
              break;
            case 'W':
              transfers[t].Frequency = 'E';
              break;
          }
          transfers[t].scheduleText = recurringTransferService.setText(transfers[t].Frequency, transfers[t].RepeatDay1, transfers[t].RepeatDay2, transfers[t].TransferStartDate);
        }
        $scope.cardTransfers = transfers;
      }).catch(function (error){
        console.log(error);
      });

    // Get Bank Transfers
    $http.get(baseURI + 'bank/transfer/auto')
      .then(function(resp){
        var transfers = resp.data.Data;
        var activeTransfers = [];
        for(var t in transfers){
          switch (transfers[t].Frequency){
            case 'M':
              transfers[t].Frequency = 'O';
              break;
            case 'W':
              transfers[t].Frequency = 'E';
              break;
          }

          if(transfers[t].Status == 'A'){
            transfers[t].scheduleText = recurringTransferService.setText(transfers[t].Frequency, transfers[t].RepeatDay1, transfers[t].RepeatDay2, transfers[t].TransferStartDate);
            activeTransfers.push(transfers[t]);
          }

        }

        $scope.bankTransfers = activeTransfers;

      }).catch(function(error){
        console.log(error);
      });

    // Get Banks
    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      var sources = resp.data.Data || [];
      for(var s in sources){
        $scope.banks[sources[s].Id] = sources[s].Name;
      }
    });

  }]);
